<template>
  <app-list
    :go-to-single-item="goToSingleItem"
    :show-alert.sync="showAlert"
    :alert-message="alertMessage"
    :alert-type="alertType"
    :search="search"
    :items="checkInSheets"
    :loading="isFetching"
    :pageNumber="pageNumber"
    :updatePageNumber="SET_PAGE_NUMBER"
    :displayMenu="isAdmin"
  >
    <template
      v-if="isAdmin"
      v-slot:action-buttons
    >
      <v-btn
        :to="{ name: 'check-in-sheet-add' }"
        class="text-none"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Create check-in sheet
      </v-btn>
    </template>
    <template v-slot:search-box>
      <v-text-field
        placeholder="Search"
        class="check-in-sheet-list__search white"
        v-model.lazy="search"
        append-icon="mdi-magnify"
        hide-details
        outlined
        dense
      />
    </template>
    <template
      v-if="isAdmin"
      v-slot:menu-options="{ item }"
    >
      <template v-for="(listItem, idx) in menuItems">
        <v-list-item
          @click.prevent.stop="listItem.handle(item)"
          dense
          :key="idx"
          link
        >
          <v-list-item-title>
            {{ listItem.title }}
          </v-list-item-title>
        </v-list-item>
        <v-divider v-if="idx < menuItems.length - 1" />
      </template>
    </template>
    <error-alert :message.sync="errors"></error-alert>
    <template v-slot:app-item="{ item }">
      <span class="pb-2"> Check In Sheet #{{ item.id }}</span>
      <span v-if="isAdmin" class="pb-2 font-weight-black text-h6">{{ item.company_name }}</span>
      <span class="pb-2">Created at: <strong>{{ item.created_at }}</strong></span>
      <span class="pb-2">Updated at: <strong>{{ item.updated_at }}</strong></span>
    </template>
  </app-list>
</template>

<script>
import AppList from "@/components/AppList.vue";
import {
  mapState as checkInSheetMapState,
  mapActions as checkInSheetMapActions,
  mapMutations,
} from "@/store/modules/checkInSheet";
import { mapState as userMapState, mapGetters as userMapGetters } from "@/store/modules/user";
import { DOWNLOAD_LINK_CUTOFF } from "@/constants.js";

export default {
  name: "CheckInSheetList",
  components: {
    AppList,
  },
  mounted() {
    if (!this.isFetchedOnce) {
      this.fetchCheckInSheets();
    }
  },
  data() {
    return {
      search: "",
      menuItems: [
        {
          title: "Edit Check in Sheet",
          handle: (item) => {
            this.$router.push({ name: "single-check-in-sheet", params: { id: item.id } });
          },
        },
        {
          title: "Delete Check-in Sheet",
          handle: (item) => {
            if (window.confirm(`Are you sure that you want to delete check-in-sheet #${item.id}?`)) {
              this.deleteCheckInSheet(item.id);
              this.displayAlert("success", "Successfully deleted sheet!");
            }
          },
        },
        {
          title: "Download Sheet",
          handle: this.downloadSheet,
        },
      ],
      showAlert: false,
      alertType: null,
      alertMessage: "",
    };
  },
  methods: {
    ...mapMutations(["SET_PAGE_NUMBER"]),
    goToSingleItem(checkInSheetID) {
      this.$router.push({ name: "single-check-in-sheet", params: { id: checkInSheetID } });
    },
    async downloadSheet(item) {
      const response = await window.axios({
        url: "/api/sheet/download/" + item.id,
        method: "POST",
        responseType: "blob",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(response.data);
      link.download = response.headers["content-disposition"].substr(
        DOWNLOAD_LINK_CUTOFF,
        response.headers["content-disposition"].length - 1
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    displayAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
    },
    ...checkInSheetMapActions(["fetchCheckInSheets", "deleteCheckInSheet"]),
  },
  computed: {
    ...checkInSheetMapState(["isFetchedOnce", "checkInSheets", "isFetching", "errors", "pageNumber"]),
    ...userMapState(["user"]),
    ...userMapGetters(["isAdmin"]),
  },
};
</script>

<style scoped>
.app-list__buttons {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto auto 1fr;
  gap: 10px;
}
.check-in-sheet-list__search {
  width: 300px;
  justify-self: end;
}
.row.check-in-sheet-list__row {
  width: 80%;
  margin: auto;
}
.check-in-sheet-list__name,
.check-in-sheet-list__company,
.check-in-sheet-list__location {
  justify-content: center;
}
.check-in-sheet-list__details {
  max-width: 400px;
  margin: auto;
}
.check-in-sheet-list__options {
  position: absolute;
  right: 10px;
}
</style>
